import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {Star} from "../../../icons/star";
import {DeviceViewModel} from "../../../models/device.view-model";
import {PlaceholderWrapperComponent} from "../../placeholder/placeholder-wrapper";
import {WithDevice} from "../../composers/with-device";

export class ScoresHeaderPlaceholderComponentProps extends BaseProps {
  device: DeviceViewModel;
}

export const ScoresHeaderPlaceholder = WithDevice((props: ScoresHeaderPlaceholderComponentProps) => {
  return (
    <PlaceholderWrapperComponent className={'scores-header-placeholder-wrapper-container'}>
      <div className={['scores-header-placeholder-content', props.device.isSmallView ? 'scores-header-placeholder-small-view' : ''].join(' ')}>
        <Star className={'scores-header-placeholder-star'}/>
        <div className={'scores-header-placeholder-center-container'}>
          <div className={'scores-header-placeholder-competition-logo'}/>
          <div className={'scores-header-placeholder-competition-and-country-container'}>
            <div className={'scores-header-placeholder-competition-name'}/>
            <div className={'scores-header-placeholder-country-name'}/>
          </div>
        </div>
      </div>
    </PlaceholderWrapperComponent>
  )
});
